import { useState } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router';
import { ArrowRight, QrCode } from 'lucide-react';
import { readJson } from '../lib/storage';
import { Button, Field } from '../ui/kit';
import { BrandMark } from '../ui/brand';

/**
 * Kök adres (app.maydaypos.com). Kurulu uygulama buradan açılır → son kullanılan işletmeye yönlenir.
 * İlk ziyaret: işletmenin karekodu zaten /{işletme} adresine götürür; elle giriş için işletme kodu alanı.
 */
export function Landing() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const fromQuery = params.get('t') ?? params.get('isletme');
  const last = readJson<string>(null, 'lastTenant');
  const [code, setCode] = useState('');

  if (fromQuery) return <Navigate to={`/${encodeURIComponent(fromQuery.toLowerCase())}`} replace />;
  if (last) return <Navigate to={`/${encodeURIComponent(last)}`} replace />;

  const slug = code.trim().toLowerCase().replace(/[^a-z0-9-]/g, '');
  return (
    <div className="card-emerald relative flex min-h-dvh flex-col overflow-hidden px-6 pt-safe">
      <div className="pointer-events-none absolute -right-24 -top-24 size-72 rounded-full bg-gold/10 blur-3xl" aria-hidden />
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center py-12">
        <BrandMark className="size-16 animate-pop" />
        <h1 className="mt-8 animate-rise text-[34px] font-extrabold leading-[1.08] tracking-[-0.03em]">
          Sevdiğin mekânın
          <br />
          <span className="gold-text">ayrıcalıkları</span> cebinde.
        </h1>
        <p className="mt-4 max-w-sm animate-rise text-[16px] leading-relaxed text-white/75 [animation-delay:80ms]">
          Her alışverişte yıldız kazan, ödüllerini kullan, sıra beklemeden sipariş ver, masanı önceden ayırt.
        </p>
        <div className="mt-10 flex animate-rise items-center gap-3 rounded-2xl bg-white/8 p-4 ring-1 ring-white/12 [animation-delay:140ms]">
          <QrCode className="size-8 shrink-0 text-gold-bright" />
          <p className="text-[14px] leading-snug text-white/85">İşletmedeki karekodu telefonunun kamerasıyla okut; uygulama o işletmeyle açılır.</p>
        </div>
      </div>
      <form
        className="mx-auto w-full max-w-md space-y-3 pb-8 pb-safe"
        onSubmit={(e) => {
          e.preventDefault();
          if (slug) nav(`/${slug}`);
        }}
      >
        <div className="rounded-3xl bg-bg p-4 text-ink shadow-float">
          <Field label="İşletme kodu" placeholder="ör. kahve-duragi" value={code} onChange={(e) => setCode(e.target.value)} autoCapitalize="none" autoCorrect="off" enterKeyHint="go" />
          <Button type="submit" block className="mt-3" disabled={!slug} icon={<ArrowRight className="size-5" />}>
            Devam et
          </Button>
        </div>
        <p className="text-center text-[12px] text-white/50">Maydaypos Super APP</p>
      </form>
    </div>
  );
}
